/** Clear unsent CI capture, recovery and planning preferences at the auth boundary. */
export function clearImprovementDrafts(): void {
  try {
    const storage = window.localStorage;
    const keys = Array.from({ length: storage.length }, (_, i) => storage.key(i));
    for (const key of keys) {
      if (key && (key.startsWith('ci-wizard-draft') || key.startsWith('ci-capture-plan:')))
        storage.removeItem(key);
    }
  } catch {
    /* Storage denial must not prevent sign-out. */
  }
}
export function installImprovementDraftSignOutCleanup(): () => void {
  const onSubmit = (event: Event) => {
    const form = event.target;
    if (
      form instanceof HTMLFormElement &&
      new URL(form.action, window.location.href).pathname === '/auth/signout'
    )
      clearImprovementDrafts();
  };
  document.addEventListener('submit', onSubmit, true);
  return () => document.removeEventListener('submit', onSubmit, true);
}
